import React from "react"

import { RichText, Wrapper } from "components"

const TextBlock = ({ content }) => (
  <Wrapper maxWidth={768}>
    <RichText
      content={{
        html: content,
      }}
    />
  </Wrapper>
)

export default TextBlock
